import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import View from './view';

/**
 * @params {any} props
 */
const ListWithDetails = (props) => {
  const { onSelect } = props;

  const navigateTo = useRef();
  const [selectedItem, setSelectedItem] = useState(props.initialItem);

  function selectItem(item) {
    const idField = props.idField || 'id';
    if (props.onClick) props.onClick(item);
    setSelectedItem(item[idField]);
    navigateTo.current?.(1);
    onSelect?.(item);
  }

  return (
    <View {...props} selectedItem={selectedItem} selectItem={selectItem} navigateTo={navigateTo} />
  );
};

ListWithDetails.propTypes = {
  items: PropTypes.array.isRequired,
  renderBadge: PropTypes.func.isRequired,
  renderDetails: PropTypes.func.isRequired,
  overrideDetails: PropTypes.element,
  title: PropTypes.string,
  onClick: PropTypes.func,
  addButton: PropTypes.element,
  loading: PropTypes.bool,
  idField: PropTypes.string,
  initialItem: PropTypes.object,
};

export default ListWithDetails;
